<template>
  <div
    class="flex p-2 items-center ms-app-banner"
    style="background: white"
  >
    <div>
      <ion-button
        fill="flat"
        size="small"
        class="close-button"
        @click="close()"
      >
        <ion-icon :icon="closeIcon" />
      </ion-button>
    </div>
    <div class="flex-shrink-0 px-2">
      <img
        src="../../public/assets/mlLogos/logo-app.png"
        width="48"
        height="48"
      >
    </div>
    <div class="px-2 flex-1">
      <div class="text-s">
        {{ t('downloadApp.titel') }}
      </div>
      <div class="text-xs">
        {{ t('downloadApp.beschreibung') }}
      </div>
    </div>
    <div>
      <AButton
        btn-primary="true"
        shape="round"
        @click="open"
      >
        {{ t('downloadApp.open') }}
      </AButton>
    </div>
  </div>
</template>

<script>

import AButton from "@/components/Base/AButton";
import { useStore } from "@/composables/useTypedStore";
import {
IonButton,
IonIcon, isPlatform
} from "@ionic/vue";
import { close as closeIcon } from "ionicons/icons";
import { useI18n } from "vue-i18n";

export default {
  name: "AppLinkBanner",
  components: {
    AButton,
    IonButton,
    IonIcon,
  },
  setup() {
    const store = useStore();
    const { t } = useI18n({ useScope: 'global' })

    const close = () => {
      store.commit('app/setShowAppLinkBanner', false)
    }

    const open = () => {
      if (isPlatform('ios')) {
        window.open('https://apps.apple.com/at/app/movers-survey/id6450960469', '_blank')
      } else if (isPlatform('android')) {
        window.open('https://play.google.com/store/apps/details?id=eu.movinglayers.movers_survey', '_blank')
      }
    }

    return {
      close,
      closeIcon,
      open,
      t
    }
  }
}
</script>

<style scoped>
.ms-app-banner {
  border-bottom: 1px solid #e4e4e4;
  z-index: 100;
}

.close-button {
  --padding-start: 0;
  --padding-end: 0;
}

</style>